import React, { useEffect, useState } from "react";
import { environmentVariables } from "../../../config/env.config";
import { useFormik } from 'formik';
import * as Yup from 'yup';
import styled from "styled-components";
import axios from "axios";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

const FormikErrorStyle = styled.div`
font-size:11px;
color: #ff3333;
padding-bottom: 5px;
`;

const ServiceForm = ({
    formCount,
    servicesData,
    setIsAddServiceDisable,
    removeForm,
    index,
    businessObjData,
    dynamicMarketplaceCategories,
    fetchCategoryData
}) => {
    // console.log(dynamicMarketplaceCategories, "<<<===dynamic")
    const [data, setData] = useState({
        formCount: formCount,
        id: null,
        name: "",
    });
    const { t } = useTranslation();
    const [tempFormCount, setTempFormCount] = useState(0);
    const [addBtnDisable, setAddBtnDisable] = useState(false);
    const [isShowAdd, setIsShowAdd] = useState(true);
    const [isEditing, setIsEditing] = useState(false);

    const validationSchema = Yup.object({
        name: Yup.string().matches(/^[\s\S]*$/, t("Alphabets_digits_special_characters_allowed"))
            .min(2, t('Minimum_2_characters_required'))
            .max(20, t('Maximum_20_characters_are_allowed'))
            .test('unique', t('Dish_category_already_exists'), value => {
                return !servicesData.some(service => service.id === value);
            }),

    });

    const formik = useFormik({
        initialValues: {
            name: data.name || '',
            id: data.id || ''
        },
        validationSchema: validationSchema,
        onSubmit: () => {
            handleAddService(formik.values.name, formik.values.id);
        },
    });

    useEffect(() => {
        let currentForm = servicesData[index];
        setTempFormCount(formCount);
        setData({
            formCount: currentForm?.formCount,
            id: currentForm?.id,
            name: currentForm?.name,
        });

        currentForm?.name ? setAddBtnDisable(true) : setAddBtnDisable(false);
        data["name"] ? setIsShowAdd(false) : setIsShowAdd(true);
    }, [servicesData]);

    useEffect(() => {
        setTempFormCount(data?.formCount);
    }, [data]);

    const handleAddService = async (nameValue, itemId) => {
        if(nameValue.trim() === '') return toast.error(t('Please_enter_dish_category'));
        try {
            const { apiUrl } = environmentVariables || {};
            const { id: businessId } = businessObjData || {};
    
            const addConfig = {
                method: isEditing ? "put" : "post",
                url: `${apiUrl}api/v1/business/${isEditing ? "updatecategory" : "createcategory"}`,
                data: isEditing 
                    ? { business_id: businessId, dishcategory: nameValue, id: itemId }
                    : { business_id: businessId, dishcategory: nameValue }
            };
    
            await axios.request(addConfig);
            toast.success(t(isEditing ? "Dish_category_updated" : "New_dish_category_added"));
    
            await fetchCategoryData();
        } catch (error) {
            console.error("Error adding category:", error);
            toast.error(error.response?.data?.message || t("An_error_occurred"));
        } finally {
            setAddBtnDisable(true);
            setIsAddServiceDisable(false);
            setIsEditing(false);
        }
    };    

    const handleEditForm = () => {
        setIsEditing(true);
        setAddBtnDisable(false);
        setIsShowAdd(true);

        formik.setValues({
            name: data.name || '',
            id: data.id || ''
        });
    };

    return (
        <div key={`form-${formCount}`} className="col-12" id="AddNewStyleFormfieldpad">
            <div className="serviceboxedit">
                <i
                    class="fa-solid fa-circle-xmark crosseditservice crossIconAdddetails"
                    onClick={() => removeForm(index, dynamicMarketplaceCategories)}
                ></i>
                <span onClick={handleEditForm} style={{ padding: "2px 45px 10px 0px", cursor: "pointer", display: "flex", justifyContent: "end" }}>
                    <i class="fa-solid fa-pen"></i>
                </span>

                <div>
                    {isShowAdd || isEditing ? (
                        <div>
                            <input
                                name="name"
                                disabled={addBtnDisable}
                                className="form-control"
                                style={{ padding: "14px 25px", marginBottom: "10px" }}
                                type="text"
                                placeholder={`${t("Name")}`}
                                value={data["name"] || ""}
                                onChange={(e) => {
                                    formik.setFieldValue('name', e.target.value);
                                    setData({ ...data, name: e.target.value, id: e.target.id });
                                }}
                                onBlur={formik.handleBlur}
                            />

                            {formik.touched.name && formik.errors.name && (
                                <FormikErrorStyle>{formik.errors.name}</FormikErrorStyle>
                            )}
                        </div>
                    ) : (
                        <div className="servicenameedit" id="ServicesEditformstyle">
                            {t(data["name"]) || ""}
                        </div>
                    )}
                </div>
                {isShowAdd && !addBtnDisable ? (
                    <button
                        type="button"
                        disabled={!formik.isValid || !formik.dirty}
                        onClick={() => {
                            formik.handleSubmit();
                        }}
                        className="btn btn-cu addbuttoneditform"
                    >
                        {isEditing ? t("Save") : t("Add")}
                    </button>
                ) : null}
            </div>
        </div>
    );
};

export default ServiceForm;